import { useParams, useNavigate } from "react-router-dom";

import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";
import CustomInputNumber from "@/components/desktop/form/input/input-number/CustomInputNumber";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";

import { useEstatesParentsForm } from "@/hooks/maintainers/estates-parents/useEstatesParentsForm";

import EstatesDaysSelector from "./EstatesDaysSelector";
import { days } from "./estatesParentsDays.js";

const EstatesParentsForm = ({ filters = {} }) => {
	const navigate = useNavigate();
	const { option, slug } = useParams();

	const onClose = () => navigate("/configuracion/grupos_campos");

	const {
		isOpen,
		modalTitle,
		isLoadingLookups,
		isLoadingSave,
		isLoadingElement,
		isFetchingElement,
		estates,
		regions,
		formState,
		setFormState,
		formErrors,
		setFormErrors,
		localities,
		handleRegionChange,
		handleSubmit,
	} = useEstatesParentsForm({ option, slug, onClose, filters });

	if (!isOpen) return null;

	const isLoading = isLoadingLookups || isLoadingSave || isLoadingElement || isFetchingElement;

	const estateOptions = estates.map((e) => ({ value: e.value, label: e.label }));

	return (
		<CustomModalForm open={isOpen} onClose={onClose} title={modalTitle} size="md" asForm onSubmit={handleSubmit} isLoading={isLoading}>
			{isLoading ? (
				<CustomFetching center size="lg" />
			) : (
				<>
					<CustomInputText
						label="Nombre"
						name="name"
						value={formState.name}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, name: value }));
							setFormErrors((prev) => ({ ...prev, name: undefined }));
						}}
						placeholder="Ingrese el nombre"
						required
						col={6}
						error={formErrors.name}
					/>

					<CustomInputSelect
						label="Bodegas"
						name="estates"
						isMulti
						options={estateOptions}
						value={formState.estates ?? []}
						onChange={(value) => setFormState((prev) => ({ ...prev, estates: value ?? [] }))}
						placeholder="Seleccionar bodegas"
						col={6}
						creatable={true}
					/>

					<CustomInputSelect
						label="Región"
						name="region"
						options={regions}
						value={formState.region}
						onChange={handleRegionChange}
						placeholder="Seleccione región"
						isClearable
						col={6}
					/>

					<CustomInputSelect
						label="Comuna"
						name="locality"
						options={localities}
						value={formState.locality}
						onChange={(value) => setFormState((prev) => ({ ...prev, locality: value ?? null }))}
						placeholder="Seleccione comuna"
						isClearable
						disabled={!localities?.length}
						col={6}
					/>

					<CustomInputNumber
						label="Cant. Hectáreas"
						name="hectares"
						value={formState.hectares ? Number(formState.hectares) : null}
						onChange={(value) => setFormState((prev) => ({ ...prev, hectares: value ?? "" }))}
						placeholder="0"
						disabled={true}
						col={6}
					/>

					<CustomInputText
						label="Hora Apertura"
						name="time_open"
						type="time"
						value={formState.time_open ?? ""}
						onChange={(value) => setFormState((prev) => ({ ...prev, time_open: value }))}
						col={6}
					/>

					<CustomInputText
						label="Hora Cierre"
						name="time_close"
						type="time"
						value={formState.time_close ?? ""}
						onChange={(value) => setFormState((prev) => ({ ...prev, time_close: value }))}
						col={6}
					/>

					<div style={{ gridColumn: "1 / -1" }}>
						{formState.day_selection === false ? (
							<div>
								<CustomInputText
									label="Frecuencia de Notificación"
									name="notification_range"
									type="number"
									value={formState.notification_range ?? ""}
									onChange={(value) => setFormState((prev) => ({ ...prev, notification_range: value }))}
									addonBefore="Cada"
									addonAfter="días"
									placeholder=""
									col={12}
								/>
								<p
									style={{ color: "#549112", cursor: "pointer", marginTop: "4px" }}
									onClick={() => setFormState((prev) => ({ ...prev, notification_range: "", day_selection: true }))}
								>
									O selecciona un día a la semana
								</p>
							</div>
						) : (
							<div>
								<EstatesDaysSelector
									notificationDays={formState.days}
									setNotificationDays={(selectedDays) => setFormState((prev) => ({ ...prev, days: selectedDays }))}
									days={days}
								/>
								<p
									style={{ color: "#549112", cursor: "pointer", marginTop: "4px" }}
									onClick={() => setFormState((prev) => ({ ...prev, days: [], day_selection: false }))}
								>
									Seleccionar intervalo de días
								</p>
							</div>
						)}
					</div>
				</>
			)}
		</CustomModalForm>
	);
};

export default EstatesParentsForm;
